import { useCallback, useMemo } from 'react';

import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { useIncidentHistory } from '@/features/IncidentHistory';

const IncidentHistoryTableColumns = (): JSX.Element => {
  return (
    <SimpleTableRow header>
      <SelectAllCell />
      <SortableCell name="STATION">Airport</SortableCell>
      <SortableCell name="INCIDENT_DATETIME">Incident Time</SortableCell>
      <SortableCell name="CREATED_AT">Created</SortableCell>
      <SortableCell name="TRIP_SERVICER_IATA_AIRLINE_CODE">AL</SortableCell>
      <SortableCell name="TRIP_FLIGHT_NAME">FLT #</SortableCell>
      <SortableCell name="TRIP_SCHEDULED">Sch Time</SortableCell>
      <SortableCell name="VEHICLE_TRACKING_ID">Van</SortableCell>
      <SortableCell name="EMPLOYEE_NAME">Employee</SortableCell>
      <SortableCell name="DRIVER_EMPLOYEE_ID">ID #</SortableCell>
      <SortableCell name="MANAGER_NAME">Manager</SortableCell>
      <SortableCell name="CREW_INVOLVED">Crew Onboard?</SortableCell>
    </SimpleTableRow>
  );
};

const SelectAllCell = (): JSX.Element => {
  const [{ incidents, selected }, setState] = useIncidentHistory(({ incidents, selected }) => ({ incidents, selected }));

  const isSelectAll = useMemo((): boolean => {
    if (selected.size !== incidents.size) return false;
    for (const id of selected.keys()) {
      if (!incidents.has(id)) return false;
    }
    return true;
  }, [incidents, selected]);

  const onClick = useCallback(
    (): void => setState((current) => ({ ...current, selected: isSelectAll ? new Map() : incidents })),
    [incidents, isSelectAll, setState]
  );

  return <SimpleTableCell.Select checked={isSelectAll} onChange={onClick} />;
};
const SortableCell = ({ name, children }: { name: string; children: React.ReactNode }): JSX.Element => {
  const [{ sortBy, sortDirection }, setState] = useIncidentHistory(({ sortBy, sortDirection }) => ({ sortBy, sortDirection }));
  const onSort = (name: string, direction: SortDirectionEnum): void =>
    setState((current) => ({ ...current, sortBy: name, sortDirection: direction }));
  return (
    <SimpleTableCell.Sortable name={name} sortBy={sortBy} sortDirection={sortDirection} onSort={onSort}>
      {children}
    </SimpleTableCell.Sortable>
  );
};

export default IncidentHistoryTableColumns;
